import * as React from "react";
import Svg, { Path, Defs, ClipPath, Rect, G } from "react-native-svg";
const DashboardIcon = (props) => (
    <Svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clipPath="url(#clip0_8164_3149)">
            <Path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill={props?.customColor ?? "black"} />
            <Path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
            <Path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill={props?.customColor ?? "black"} fillOpacity="0.2" />
        </G>
        <Defs>
            <ClipPath id="clip0_8164_3149">
                <Rect width="24" height="24" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default DashboardIcon;
